// ─── Module « meals » (@mop/feature-meals) ───────────────────────
// Recettes + Repas (compositions) + Menus (grille hebdo) + Semaines
// (application du menu au calendrier) + liste de courses + référentiel
// d'ingrédients.
export { FONCTIONS_REPAS } from './fonctions';

// Écrans de l'app My Meals.
export { default as EcranRecettes } from './EcranRecettes';
export { default as EcranRepas } from './EcranRepas';
export { default as EcranMenus } from './EcranMenus';
export { default as EcranSemaines } from './EcranSemaines';
export { default as EcranIngredients } from './EcranIngredients';
export { default as EcranCourses } from './EcranCourses';

// Recettes (bibliothèque).
export {
  ecouterRecettes, creerRecette, modifierRecette, supprimerRecette, coutRecette,
} from './services/recettes';

// Import / export de recettes (JSON MoPCal + Schema.org/Recipe).
export { recettesVersMoPCal, recettesVersSchemaOrg, parseImportRecettes, parseIngredientTexte } from './services/recettesIO';
export { exporterFichier, choisirEtLireFichier } from './services/io';

// Repas (compositions : recettes + extras).
export {
  ecouterRepasComposes, creerRepas, modifierRepas, supprimerRepas, dupliquerRepas,
  coutRepas, resumeRepas,
} from './services/repasComposes';

// Semaines : affecter un menu-type a une semaine reelle, l appliquer au
// calendrier (les repas deviennent des evenements) ou l en retirer.
export {
  ecouterSemaines, prochainesSemaines, joursSemaine, lundiDe,
  affecterMenu, appliquerMenu, desappliquerMenu, detacherSemaine, noteRepas,
} from './services/semaines';

// Planning (config + menus-types).
export {
  JOURS_SEMAINE, MOMENTS_DEFAUT, cleCaseRepas, normaliserHeureRepas,
  ecouterRepasConfig, enregistrerRepasConfig, momentsDe, momentsDuMenu,
  CATEGORIES_RECETTE_DEFAUT, categoriesRecetteDe, categorieRecetteDe, ordreCategorieRecette,
  ecouterMenus, creerMenu, enregistrerMenu, supprimerMenu, dupliquerMenu,
  affecterRepasCase, affecterRecetteCase, affecterLibreCase, viderCase,
} from './services/menus';

// Mise à l'échelle par nombre de personnes (pur).
export { personnesRecette, personnesRepas, personnesCase, nbPersonnesDe } from './services/personnes';

// Référentiel d'ingrédients — base globale (partagée, lecture seule) +
// calque personnel (ajouts/masques par uid). Réutilisable (recettes, futur
// stock).
export { RAYONS, rayonDe, ordreRayon } from './services/catalogueIngredients';
export { ecouterBase } from './services/ingredientsBase';
export {
  ecouterPerso, ajouterPersonnel, modifierAjout, retirerAjout,
  masquerBase, demasquerBase, modifierBase, annulerModifBase, ingredientsEffectifs,
  ajouterRayon, modifierRayonAjoute, retirerRayonAjoute,
  masquerRayonBase, demasquerRayonBase, modifierRayonBase, annulerModifRayonBase, rayonsEffectifs,
} from './services/ingredientsPerso';

// Liste de courses (alimentée manuellement ou depuis une recette/un repas,
// mis à l'échelle du nombre de personnes).
export { ingredientsRecetteEchelle, ingredientsRepasEchelle } from './services/courses';
export { coursesDesMenus, menusDesSemaines } from './services/coursesMenu';
export {
  ecouterListeCourses, enregistrerListeCourses, fusionnerDansListe,
  basculerCoche, retirerItem, viderCoches,
} from './services/listeCourses';
